export { default } from './FeeTotalsBar';
